module.exports = __webpack_public_path__ + "img/login-logo.f1b7fcf5.svg";